// extracted by mini-css-extract-plugin
export default {"page":"w5M8S","inner":"TTi6N"};